import Container from '../../atoms/container/pilotContainer';
import Mask from './pilotMask';
import Vod from './pilotVod';
import Zapper from './pilotZapper';
import { PilotProps as Props } from '../../../../shared/types/props/pilot';

function Pilot({ channel, vod }: Props) {
  return (
    <Container>
      <Mask />
      {vod ? <Vod asset={vod} /> : null}
      {channel ? <Zapper asset={channel} /> : null}
    </Container>
  );
}

export default Pilot;
